import { atom } from "jotai";
import useHttp from "../hooks/useHttp";
import { getZipFromResponce } from "../utils/getZipFromResponse";

export const productsInfoAtom = atom(null);

const createLocalStorageAtom = (key, defaultValue) => {
  const baseAtom = atom(localStorage.getItem(key) || defaultValue);
  return atom(
    (get) => get(baseAtom),
    (get, set, newValue) => {
      set(baseAtom, newValue);
      localStorage.setItem(key, newValue);
    },
  );
};

export const categoriesPageModeAtom = createLocalStorageAtom(
  "categoriesPageMode",
  "products",
);

export const productsLoadingStatusAtom = atom("idle");
export const currentPageAtom = atom(1);
export const allPagesAtom = atom(1);
export const productPerPageAtom = atom(0);
export const allProductsAtom = atom(0);
export const filtersLoadingStatusAtom = atom("loading");
export const filterInfoAtom = atom(null);
export const sortByAtom = atom("landed_cpr");
export const roundsAtom = atom("rounds");
export const retailerAtom = atom("retailer");
export const shippingAtom = atom("shipping");
export const openStickyFilterAtom = atom(false);
export const openMobileFilterAtom = atom(false);
export const selectedFiltersAtom = atom({
  bw: [],
  vid: [],
  brnd: [],
  sf: [1, 2],
  bullet_type_s: [],
  bt: [],
  shell_length: [],
  mt: [],
  rpb: [],
  condition: [],
  s_in: "",
  s_out: "",
});

export const appliedFiltersAtom = atom({
  bw: [],
  vid: [],
  brnd: [],
  sf: [1, 2],
  bullet_type_s: [],
  bt: [],
  shell_length: [],
  mt: [],
  rpb: [],
  condition: [],
  s_in: "",
  s_out: "",
});

export const fetchProductsAtom = atom(null, async (get, set, query) => {
  set(productsLoadingStatusAtom, "loading");
  set(filtersLoadingStatusAtom, "loading");
  const { getListings } = useHttp();

  try {
    const response = await getListings(query);

    if (response && response.response && response.facets) {
      set(productsInfoAtom, response.response.data);
      set(
        allPagesAtom,
        Math.ceil(+response.response.total / +response.response.per_page),
      );
      set(productPerPageAtom, response.response.per_page);
      set(allProductsAtom, response.response.total);
      set(filterInfoAtom, response.facets);

      if (response.ip_response && response.ip_response.ip_data) {
        getZipFromResponce(response.ip_response.ip_data.zip);
      }

      return response;
    } else {
      console.error("Invalid API response structure:", response);
      set(productsInfoAtom, []);
      set(allPagesAtom, 1);
      set(productPerPageAtom, 0);
      set(allProductsAtom, 0);
      set(filterInfoAtom, null);
      return null;
    }
  } catch (error) {
    console.error("Error fetching products:", error);
    set(productsInfoAtom, []);
    set(allPagesAtom, 1);
    set(productPerPageAtom, 0);
    set(allProductsAtom, 0);
    set(filterInfoAtom, null);
    return null;
  } finally {
    set(productsLoadingStatusAtom, "idle");
    set(filtersLoadingStatusAtom, "idle");
  }
});
